import { useThemeSlice } from "../../components/ui/StatusBadge.jsx";

export function AccountTabPlaceholder({ title, description }) {
  const { c } = useThemeSlice();
  return (
    <div style={{ border: `1px dashed ${c.cardBdr}`, borderRadius: 12, padding: "48px 24px", textAlign: "center", color: c.sub }}>
      <p style={{ margin: 0, fontSize: 15, fontWeight: 700, color: c.text }}>{title}</p>
      <p style={{ margin: "8px 0 0", fontSize: 13, lineHeight: 1.55, maxWidth: 420, marginInline: "auto" }}>{description}</p>
    </div>
  );
}
